import type { Recurrence } from '@frontend/api-types';
import { FlatList, LinkButton, Text, XStack, YStack } from '@frontend/web-react';
import { useNavigate } from '@tanstack/react-router';
import { ScheduledTaskCard } from './ScheduledTaskCard';

type ScheduledTasksContainerProps = {
  recurrences: Recurrence[];
};

export const ScheduledTasksContainer = ({ recurrences }: ScheduledTasksContainerProps) => {
  const navigate = useNavigate();
  return (
    <YStack className="gap-sm px-md">
      <YStack className="gap-xs">
        <XStack className="w-full items-center justify-between">
          <Text type="h4">Looking ahead</Text>
          {recurrences.length > 3 ? (
            <LinkButton
              color="secondary"
              label="See all"
              onClick={() => navigate({ to: '/app/recurrence' })}
              type="p-sm"
            />
          ) : null}
        </XStack>
        <Text color="tertiary" type="caption">
          Your scheduled tasks
        </Text>
      </YStack>
      <FlatList
        contentContainerClassName="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3"
        data={recurrences.slice(0, 3)}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => <ScheduledTaskCard recurrence={item} />}
      />
    </YStack>
  );
};
